import styled from 'styled-components';

export const IndexTitle = styled.h1`
  font-size: 24px;
  line-height: 29px;
  min-height: 29px;
  font-weight: bold;
  color: #4f5ea3;
  margin: 0;
  text-align: center;
`;
